import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "max-double-line"
};
import { computed } from '../../../../../adapter-vue';
import { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRect, getScrollInfo } from '@tencentcloud/universal-api';
import { isUniFrameWork } from '../../../../../utils/env';
import { Toast, TOAST_TYPE } from '../../../../../components/common/Toast/index';
import { decodeTextMessage } from '../../../utils/emojiList';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      default: () => ({})
    }
  },
  emits: ["scrollTo", "blinkMessage"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var selfAddValue = 0;
    var messageList = [];
    TUIStore.watch(StoreName.CHAT, {
      messageList(list) {
        messageList = list;
      }
    });
    var quoteContent = computed(() => {
      try {
        var _props$message;
        var cloudCustomData = JSON.parse(((_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.cloudCustomData) || '{}');
        return cloudCustomData.messageReply;
      } catch (error) {
        return undefined;
      }
    });
    function scrollToOriginalMessage() {
      return _scrollToOriginalMessage.apply(this, arguments);
    }
    function _scrollToOriginalMessage() {
      _scrollToOriginalMessage = _asyncToGenerator(function* () {
        var _quoteContent$value;
        var originMessageID = (_quoteContent$value = quoteContent.value) === null || _quoteContent$value === void 0 ? void 0 : _quoteContent$value.messageID;
        var isOriginalMessageInScreen = messageList.some(msg => msg.ID === originMessageID);
        if (originMessageID && isOriginalMessageInScreen) {
          try {
            var scrollViewRect = yield getBoundingClientRect('#messageScrollList', 'messageList');
            var originalMessageRect = yield getBoundingClientRect('#tui-' + originMessageID, 'messageList');
            var {
              scrollTop
            } = yield getScrollInfo('#messageScrollList', 'messageList');
            var finalScrollTop = originalMessageRect.top + scrollTop - scrollViewRect.top - selfAddValue++ % 2;
            var isNeedScroll = originalMessageRect.top < scrollViewRect.top;
            if (!isUniFrameWork && window) {
              var scrollView = document.getElementById('messageScrollList');
              if (isNeedScroll && scrollView) {
                scrollView.scrollTop = finalScrollTop;
              }
            } else if (isUniFrameWork && isNeedScroll) {
              emits('scrollTo', finalScrollTop);
            }
            emits('blinkMessage', originMessageID);
          } catch (error) {
            console.error(error);
          }
        } else {
          Toast({
            message: TUITranslateService.t('TUIChat.无法定位到原消息'),
            type: TOAST_TYPE.WARNING
          });
        }
      });
      return _scrollToOriginalMessage.apply(this, arguments);
    }
    return (_ctx, _cache) => {
      return _unref(quoteContent) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          'reference-content': true,
          'reverse': _ctx.message.flow === 'out'
        }),
        onClick: scrollToOriginalMessage
      }, [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(quoteContent).messageSender) + ": " + _toDisplayString(_unref(decodeTextMessage)(_unref(quoteContent).messageAbstract)), 1)], 2)) : _createCommentVNode("", true);
    };
  }
});